import $R from '../lib/relay.js'

// --- Login Screen ---
function LoginScreen(){
  function signIn(){
    const urlParams = new URLSearchParams(window.location.search)
    const user = document.getElementById("user")
    const password = document.getElementById("password")
  
    const state = urlParams.get('state')
    const redirect_uri = urlParams.get('redirect_uri')
    $R.save("Login",{act:"authenticate",alias:user.value,password:password.value,dt_ck:"alias,password",state:state,redirect_uri:redirect_uri}).then((rsp)=>{
      window.location.href="/"
    }).catch(err=>console.log(err))
  }
  

  return (
    <div>
      <h1>Login</h1>
      <form>
        <div>
          <label htmlFor="user">User</label>
          <input type="text" name="user" id="user" autoComplete="username"></input>
        </div>
        <div>
          <label htmlFor="password">Password</label>
          <input type="password" name="password" id="password" autoComplete="current-password"></input>
        </div>
        <div>
          <button type="button" id="sign_in" onClick={signIn}>Sign In</button>
        </div>
      </form>
    </div>
  )
}
export default LoginScreen